/**
 * Discover the backend location during runtime from an injected window property
 * that gets created by the env.js file. This makes it possible to use the same
 * container build for different environments by just injecting the settings
 * before starting the serving of the app.
 */
export const ENV = {
  backendUrl: window.ENV?.backendUrl || 'http://localhost:4000',
}

console.info(`✅ Discovered backend urls from ENV: ${ENV.backendUrl}`)
